import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrHouseholdActionItem from 'client/components/SrHouseholdActionsList/SrHouseholdActionItem';

const SrHouseholdActionsList = ({ householdActions }) => {
  return (
    <SrBox maxHeight="200px" overflowY="scroll" width="100%" padding="0 0 0 8px">
      {householdActions.map((householdAction) => (
        <SrHouseholdActionItem
          key={householdAction.id}
          userName={householdAction.userName}
          createdAt={householdAction.createdAt}
          actionType={householdAction.actionType}
          createdByUserName={householdAction.createdByUserName}
        />
      ))}
    </SrBox>
  );
};

SrHouseholdActionsList.propTypes = {
  householdActions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      userName: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      actionType: PropTypes.string.isRequired,
      createdByUserName: PropTypes.string,
    }),
  ).isRequired,
};

SrHouseholdActionsList.displayName = 'SrHouseholdActionsList';

export default SrHouseholdActionsList;
